import type { CSSProperties } from 'react';

/**
 * Style constants for the Eval and RAG screens.
 *
 * Separate from panel.tsx because that file exports components: React Fast
 * Refresh only works when a module exports components alone.
 */

/** Status tone. One meaning, one colour, everywhere it appears. */
export type Tone = 'success' | 'warn' | 'danger' | 'info' | 'neutral';

/** Card surface. Depth comes from layered shadow, not a hard border. */
export const PANEL = 'ui-panel';

/** Avoids an orphan on the last line of a description. */
export const PRETTY: CSSProperties = { textWrap: 'pretty' };

/** Places an element in the stagger sequence. `--i` is a custom property, which
 *  CSSProperties cannot describe, so the cast is the narrowest one available. */
export const riseAt = (i: number): CSSProperties => ({ '--i': i } as CSSProperties);
